import React, {useState, useEffect, forwardRef, useRef, useMemo, useImperativeHandle} from 'react'
import {Image, Space, PreviewGroup, Modal, Popover, Button, Tooltip} from '@bedrock/components'
import {ChevronDown, Upload } from '@bedrock/icons-react'
import {useMemoizedFn} from 'ahooks'
import classNames from 'classnames/bind'
import styles from './index.less'
import { SUpload, AttachmentDots } from '#components/SForm/SFormElement/SUpload'
import TextAreaPopover from '#components/SForm/SFormElement/TextAreaPropover'
import { apiService, defs } from '#services'

const cx = classNames.bind(styles)

type ClosingReportProps = {
  quote_key?: string,
  value?: defs.DemandSupplierQuoteSettleReportDto
  onChange?: (value:defs.DemandSupplierQuoteSettleReportDto) => void
  view?: boolean
}


const ClosingReport = forwardRef((props: ClosingReportProps, ref) => {
  const {quote_key} = props
  const {value = {content: '', attachments: [], quote_key, attach_blob_ids: []}, onChange, view = false} = props
  const uploadRef = useRef<any>(null)

  const [localFileList, setLocalFileList] = useState<any[]>(value?.attachments || [])

  const isUploading = useMemo(() => {
    return localFileList.some((n) => n.status === 'uploading')
  }, [localFileList])

  const validateFields = useMemoizedFn(() => {
    return new Promise((resolve, reject) => {
      if(uploadRef.current) {
        uploadRef.current?.validateFields?.()
          .then(() => {
            if(value.content || value.attachments?.length) {
              resolve(true)
            } else {
              reject('请输入结案报告或上传文件')
            }
          })
          .catch(reject)
      } else {
        resolve(true)
      }
    })
  })

  useImperativeHandle(ref, () => {
    return {
      validateFields
    }
  })

  return <div className={cx('closing-report')}>
      <div className={cx('text-area-container')}>
        <TextAreaPopover
          view={view}
          value={value.content}
          onChange={(e) => {
            onChange({ ...value, quote_key, content: e?.trim?.() || '' })
          }}
        />
      </div>
      <Space className={cx('upload-container')} size={[8, 0]}>
        {!view && <SUpload
          className={cx('upload-button')}
          fileList={value.attachments as any}
          onChange={(file) => {
            onChange({ ...value, quote_key, attachments: file.dataList, attach_blob_ids: file.dataList.map((item: any) => item.blob.id) })
            setLocalFileList(file.fileList)
          }}
          ref={uploadRef}
          trigger={<Tooltip
            title={'上传附件：单个文件不超过 200M'}
            placement="topRight"
          >
            <Button
              type="checked-neutral"
              className={cx('upload-trigger')}
              icon={<Upload />}
              loading={isUploading}
            />
          </Tooltip>}
          tip={null}
        />}
        {!!value?.attachments?.length && <Popover
          content={<div className={cx('upload-popover-content')}>
            <SUpload
              className={cx('upload-list')}
              maxFileSize={200 * 1024 * 1024}
              multiple
              fileList={value.attachments as any}
              onChange={(file) => {
                onChange({ ...value, attachments: file.dataList, attach_blob_ids: file.dataList.map((item: any) => item.blob.id) })
                setLocalFileList(file.fileList)
              }}
              view={view}
              tip={null}
            />
          </div>}
          trigger="click"
          disabled={!value?.attachments?.length}
        >
          <Button type="link" className={cx('upload-trigger')} suffixIcon={<ChevronDown />}>
          {view ? `${value?.attachments?.length || 0}个附件` : `共${value?.attachments?.length || 0}个`}
          </Button>
        </Popover>}
        {!value?.attachments?.length && !!view
          && <span className={cx('file-empty-tip')}>
            无附件
          </span>}
      </Space>
    </div>
})

export default ClosingReport
